/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { ESessionPhase } from '@lbs/shared-rp-types'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useRussianPokerStore } from '../../providers/RussianPokerProvider'
import CardHolder, { mapDealerToCardHolderVM } from '../CardHolder'
import { StyledDecisionBox } from '../DecisionBox'
import { Typography } from '../Typography'

const BoxDealer: FC = observer(() => {
  const { t } = useTranslation()
  const { session } = useRussianPokerStore()
  const isDealerView = [
    ESessionPhase.FINISHED,
    ESessionPhase.SETTLEMENT,
  ].includes(session.phase)

  const cardHolderVM = mapDealerToCardHolderVM({
    cards: session.cards,
    handName: session.hand.handName,
    isDetailView: isDealerView,
  })

  return (
    <StyledDecisionBox>
      <Typography
        as="div"
        variant="dealer"
        color="white"
        css={css`
          opacity: 0.5;
          padding-bottom: 4px;
          text-shadow: 0 0 7px #ffd373;
        `}>
        {t('dealer')}
      </Typography>
      <CardHolder viewModel={cardHolderVM} />
    </StyledDecisionBox>
  )
})

export default BoxDealer
